<template>
  <div>
    <div class="spinner-wrapper">
        <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    </div>

    <nav-section></nav-section>

    <!-- Details 1 -->
    <div style="margin: 87px 0 0 0; padding: 1em;">
      <div class="container">
          <div class="row">
            <div class='col' style="padding:1em;">
              <h3>About Us</h3>
            </div>
          </div>
      </div>
    </div>

    <img class="img-fluid" src="../assets/images/Comic_Banner.jpg" style="width:100%;">

    <div class="website-body">
        <div class="container">
          <div class="row">
            <div class='col' style="padding:1em;">
              <h4>Overview</h4>
              <hr/>
              <p style="font-size:1.2em;">
                One day a wizard and a sorcerer were experimenting in an Arcane Lab and by pure luck a company was born. We love to find additional ways to put your dice to work! Our goal is to create products that make people happy and deliver a little bit of extra magic to your gaming table.
              </p>
            </div>
          </div>
      </div>
      <div class="container" style="padding-top:2em;">
          <div class="row">
            <div class='col'>
              <h4>Meet the Team</h4>
              <hr/>
            </div>
          </div>
          <div class="row">
            <div class='col'>
              <div class="container table">
                <div class="row">
                  <div class="col-sm" style="padding:0.5em;font-size:1.2em;">
                    <img class="img-fluid" src="../assets/images/katlyn_headshot.png" style="width:300px;">
                      <h5>Katlyn</h5>
                  </div>
                  <div class="col-sm" style="padding:0.5em;font-size:1.2em;">
                    <img class="img-fluid" src="../assets/images/jared_headshot.png" style="width:300px;">
                    <h5>Jared</h5>
                  </div>
                </div>
                <div class="row table-border" v-for="item in question_table" :key="item.question">
                  <div class="col-sm" style="padding:0.5em;font-size:1.2em;">
                    {{item.katlyn}}
                  </div>
                  <div class="col-sm" style="padding:0.5em;font-size:1.2em;">
                    {{item.jared}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>

    <copyright-section></copyright-section>
  </div>
</template>

<script>
import NavSection from './NavSection'
import CopyrightSection from './CopyrightSection'

export default {
  name: 'AbooutPage',
  methods: {

  },
  data () {
    return {
      question_table: [
        {
          'question': 'Arcane Spectacles Role',
          'katlyn': 'Business Owner | Creative Direction | Fullfillment',
          'jared': 'Product Design | Production | Operations'
        },
        // {
        //   'question': 'Favorite D&D Class',
        //   'katlyn': 'Wizard',
        //   'jared': 'Sorcerer'
        // },
        // {
        //   'question': 'Day Job',
        //   'katlyn': 'CT Technologist',
        //   'jared': 'Software Engineer'
        // },
        // {
        //   'question': 'Dungeon Master or Player',
        //   'katlyn': 'Player',
        //   'jared': 'Dungeon Master'
        // }
      ]
    }
  },
  components: {
    NavSection,
    CopyrightSection
  }
}
</script>


// WEBPACK FOOTER //
// src/components/AboutPage.vue